import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MainLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

export default function DataLoader() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");

    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }

    setIsLoading(false);
  }, [navigate]);

  if (isLoading) {
    return <MainLoader />;
  }

  return null; 
}